import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import Person4OutlinedIcon from '@mui/icons-material/Person4Outlined';
import AppsIcon from '@mui/icons-material/Apps';
import { palettes } from '../../../../common/themes/palletes';

interface IPrefixIcon {
  name: string;
  enable: boolean;
}
export const PrefixIcon: React.FC<IPrefixIcon> = ({ name, enable }) => {
  if (name === "Landing Page" || name === "Facilities") {
    return (
      <svg
        width="16"
        height="19"
        viewBox="0 0 16 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.5 14.5H9.5V12H12V9H9.5V6.5H6.5V9H4V12H6.5V14.5ZM0 18.5V6.5L8 0.5L16 6.5V18.5H0ZM2 16.5H14V7.5L8 3L2 7.5V16.5Z"
          fill={enable ? palettes.$primaryColor : palettes.$secondaryTextColor}
        />
      </svg>
    );
  }
  if(name === "Clients"){
    return(
      <PeopleAltOutlinedIcon sx={{ color: enable ? palettes.$primaryColor : palettes.$secondaryTextColor}} />
    );
  }
  if(name === "Products" || name === "BizBox Users" || name === "Manage Accessibility"){
    return(
      <AppsIcon sx={{ color: enable ? palettes.$primaryColor : palettes.$secondaryTextColor}} />
    );
  }
  if(name === "Group Admins" || name === "Facility Users"){
    return(
      <Person4OutlinedIcon sx={{ color: enable ? palettes.$primaryColor : palettes.$secondaryTextColor}} />
    );
  }

  return <>none</>;
};
